import { Alert, AlertTitle } from '@mui/material'

import { useController } from '../../../hooks/useController'
import { useTexts } from '../useTexts'

export function SuccessBody() {
  const {
    data: {
      values: { notificationWay },
    },
  } = useController()

  const texts = useTexts()

  if (!notificationWay) return null

  return (
    <Alert severity="success" icon={false}>
      <AlertTitle>{texts.getSuccessTitle(notificationWay)}</AlertTitle>
      {texts.getSuccessDescription(notificationWay)}
    </Alert>
  )
}
